import React, { useState, useEffect } from 'react';
import { Button } from '../ui';
import { DISTRICTS } from '../../data/districts';
import { SALES_EMAIL } from '../../data/marketing';

const ROLES = ['Superintendent', 'Athletic Director', 'Fine Arts Director', 'Principal', 'Event Coordinator', 'Secretary', 'Other'];
const TO = SALES_EMAIL || 'info@valley-tickets.com';

// "Request Demo" modal. Collects details and opens a prefilled email on submit
// (no backend). Looks like a real lead form.
const RequestDemoModal = ({ open, onClose }) => {
  const [name, setName] = useState('');
  const [district, setDistrict] = useState('');
  const [role, setRole] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && onClose();
    if (open) document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  const submit = (e) => {
    e.preventDefault();
    const subject = `Valley Tickets demo request${district ? ` - ${district}` : ''}`;
    const body =
      `Name: ${name}\nDistrict: ${district}\nRole: ${role}\nEmail: ${email}\n\n${message || 'I would like to schedule a Valley Tickets demo for my district.'}`;
    window.location.href = `mailto:${TO}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-ink-900/60 backdrop-blur-sm" onClick={onClose} role="dialog" aria-modal="true">
      <div className="bg-white rounded-3xl shadow-lift w-full max-w-md overflow-hidden animate-fade-in-up" onClick={(e) => e.stopPropagation()}>
        <div className="px-6 py-5 bg-brand-gradient text-white">
          <h3 className="text-xl font-bold font-display">Request a demo</h3>
          <p className="text-sm text-brand-100 mt-0.5">See Valley Tickets branded for your district.</p>
        </div>
        <form onSubmit={submit} className="p-6 space-y-3">
          <input required value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name"
            className="w-full px-4 py-2.5 rounded-xl border border-ink-200 outline-none focus:ring-2 focus:ring-brand-300" />
          <select required value={district} onChange={(e) => setDistrict(e.target.value)}
            className="w-full px-4 py-2.5 rounded-xl border border-ink-200 outline-none focus:ring-2 focus:ring-brand-300 text-ink-700">
            <option value="">Select your district</option>
            {DISTRICTS.map((d) => <option key={d.slug} value={d.name}>{d.name}</option>)}
            <option value="Other">Other</option>
          </select>
          <select required value={role} onChange={(e) => setRole(e.target.value)}
            className="w-full px-4 py-2.5 rounded-xl border border-ink-200 outline-none focus:ring-2 focus:ring-brand-300 text-ink-700">
            <option value="">Your role</option>
            {ROLES.map((r) => <option key={r} value={r}>{r}</option>)}
          </select>
          <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Work email"
            className="w-full px-4 py-2.5 rounded-xl border border-ink-200 outline-none focus:ring-2 focus:ring-brand-300" />
          <textarea value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Anything specific you'd like to see? (optional)" rows={3}
            className="w-full px-4 py-2.5 rounded-xl border border-ink-200 outline-none focus:ring-2 focus:ring-brand-300 resize-none" />
          <Button type="submit" className="w-full" size="lg">Send request</Button>
          <p className="text-center text-xs text-ink-400">Opens your email to {TO}. We'll reply to schedule.</p>
        </form>
      </div>
    </div>
  );
};

export default RequestDemoModal;
